import { render, staticRenderFns } from "./JoinNow.vue?vue&type=template&id=40df2bed&scoped=true&"
import script from "./JoinNow.vue?vue&type=script&lang=js&"
export * from "./JoinNow.vue?vue&type=script&lang=js&"
import style0 from "./JoinNow.vue?vue&type=style&index=0&id=40df2bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df2bed",
  null
  
)

export default component.exports